import type { ComponentType } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import LineBedSofaIcon from 'LuxKit/Icons/line/LineBedSofaIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineClochIcon from 'LuxKit/Icons/line/LineClochIcon'
import LineClockIcon from 'LuxKit/Icons/line/LineClockIcon'
import LineDumbbellIcon from 'LuxKit/Icons/line/LineDumbbellIcon'
import LineFamilyIcon from 'LuxKit/Icons/line/LineFamilyIcon'
import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineGolfIcon from 'LuxKit/Icons/line/LineGolfIcon'
import LineGrapesIcon from 'LuxKit/Icons/line/LineGrapesIcon'
import LineHeartCardIcon from 'LuxKit/Icons/line/LineHeartCardIcon'
import LineKidIcon from 'LuxKit/Icons/line/LineKidIcon'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import LineParkingIcon from 'LuxKit/Icons/line/LineParkingIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import LineSkiLiftIcon from 'LuxKit/Icons/line/LineSkiLiftIcon'
import LineSnowFlakeIcon from 'LuxKit/Icons/line/LineSnowFlakeIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineSunsetIcon from 'LuxKit/Icons/line/LineSunsetIcon'
import LineSwimmerIcon from 'LuxKit/Icons/line/LineSwimmerIcon'
import LineTheatreIcon from 'LuxKit/Icons/line/LineTheatreIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineUtensilsIcon from 'LuxKit/Icons/line/LineUtensilsIcon'
import LineWalkingIcon from 'LuxKit/Icons/line/LineWalkingIcon'
import LineWaterIcon from 'LuxKit/Icons/line/LineWaterIcon'
import LineWellnessIcon from 'LuxKit/Icons/line/LineWellnessIcon'
import LineWheelchairIcon from 'LuxKit/Icons/line/LineWheelchairIcon'
import LineWifiIcon from 'LuxKit/Icons/line/LineWifiIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { type OfferPageHighlightTagIcon } from './offerPageHighlightTagConstants'
import { type OfferPageHighlightTag } from './useOfferPageHighlightTags'

const IconContainer = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.default.six};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: ${rem(40)};
  justify-content: center;
  width: ${rem(40)};
`

const highlightTagIcons: Record<OfferPageHighlightTagIcon, ComponentType> = {
  'bed-sofa': LineBedSofaIcon,
  car: LineCarIcon,
  cloch: LineClochIcon,
  clock: LineClockIcon,
  dumbbell: LineDumbbellIcon,
  family: LineFamilyIcon,
  'glass-martini': LineGlassMartiniAltIcon,
  golf: LineGolfIcon,
  grapes: LineGrapesIcon,
  'heart-card': LineHeartCardIcon,
  kid: LineKidIcon,
  'map-marker': LineMapMarkerIcon,
  parking: LineParkingIcon,
  plane: LinePlaneDepartureIcon,
  restaurant: LineRestaurantIcon,
  shop: LineShopIcon,
  'ski-lift': LineSkiLiftIcon,
  'snow-flake': LineSnowFlakeIcon,
  star: LineStarIcon,
  sunset: LineSunsetIcon,
  swimmer: LineSwimmerIcon,
  theatre: LineTheatreIcon,
  trees: LineTreesIcon,
  utensils: LineUtensilsIcon,
  walking: LineWalkingIcon,
  water: LineWaterIcon,
  wellness: LineWellnessIcon,
  wheelchair: LineWheelchairIcon,
  wifi: LineWifiIcon,
}

interface Props {
  tag: OfferPageHighlightTag
}

function OfferPageHighlightTagItem(props: Props) {
  const { tag } = props
  const HighlightIcon = highlightTagIcons[tag.icon]

  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <IconContainer><HighlightIcon /></IconContainer>
    <div>
      <Heading variant="heading6">{tag.title}</Heading>
      <BodyText variant="medium" colour="neutral-two">{tag.description}</BodyText>
    </div>
  </Group>
}

export default OfferPageHighlightTagItem
